export const PASSWORD_MIN_LENGTH = 8;
